import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { DealEvent } from '@psp-aggregator/sdk';

interface DealEventLogProps {
  events: DealEvent[];
  language: string;
}

export const DealEventLog: FC<DealEventLogProps> = ({ events, language }) => {
  const { t } = useTranslation();

  if (events.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        {t('pages.admin.deals.ticket.noEvents')}
      </p>
    );
  }

  return (
    <ol className="space-y-2">
      {events.map((event) => (
        <li
          key={event.id}
          className="border-l-2 border-primary/30 py-1 pl-3 text-sm">
          <div className="flex flex-wrap justify-between gap-2">
            <span className="font-medium text-foreground">
              {event.event_type.replaceAll('_', ' ')}
            </span>
            <time className="text-xs text-muted-foreground">
              {new Intl.DateTimeFormat(language, {
                dateStyle: 'medium',
                timeStyle: 'short',
              }).format(new Date(event.created_at))}
            </time>
          </div>
          {!!event.comment && (
            <p className="mt-1 text-muted-foreground">{event.comment}</p>
          )}
        </li>
      ))}
    </ol>
  );
};

DealEventLog.displayName = 'DealEventLog';
